import { images } from "../constants";

const downloadApp = {  
    sub: "Download Our App",
    heading: "Download Our App & Rent on the Go",
    content: "Book your rental car anytime, anywhere. Our app makes it easy to browse our fleet, compare prices, and reserve your perfect vehicle. Enjoy the convenience of mobile booking, in-app navigation, and seamless customer support.",
    image: images.mobileApp,
    buttons: [
        {
            id: 1,
            image: images.appStoreBtn,
            alt: "Download on Google Play",
            link: "#"
        },
        {
            id: 2,
            image: images.playStoreBtn,
            alt: "Download on the App Store",
            link: "#"
        }
    ],
    qrCode: {
        image: images.barCode,
        alt: "Download Bar Code",
        link: "#"
    }
}

export default downloadApp;
